import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  body: {
    padding: theme.spacing(5),
  },
  responsiblesGrid: {
    paddingTop: theme.spacing(2),
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridGap: theme.spacing(3),

    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'auto',
    },
  },
  responsibleTile: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridGap: theme.spacing(3),
  },
  responsibleName: {
    display: 'grid',
  },
}));
